// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1ZaJT","log":"ModalInventoryLogs_log__3Ya3i","date":"ModalInventoryLogs_date__3BS5F","userName":"ModalInventoryLogs_userName__H7INl"};